import React, { Component } from "react";
import Select from "react-select/creatable";
import { formatCurrency } from "../../utils/helpers";

export default class ItemsCompra extends Component {
    state = {
        id: false,
        nombre: false,
        grupo: false,
        cantidad: 0,
        costo: 0,
        descuento: 0,
    };
    componentDidMount() {
        window.addEventListener('update-itbis', this.calculateTotals);
    };
    onChangeInput = async (name, value) => {
        await this.setState({
            [name]: value
        });

        this.calculateTotals();
    };
    calculateTotals = () => {
        const { cantidad, costo, descuento } = this.state;
        const { item } = this.props;

        const desc       = this.calcularDescuento(costo, descuento);
        const total      = this.calcularTotal(costo, desc, cantidad);
        const itbisTotal = this.calcularItbis(total);
        const subtotal   = this.calcularSubtotal(total, itbisTotal);

        this.props.updateTotal(
            item.id,
            subtotal,
            itbisTotal,
        );
    }
    onChangeGrupo = e => {
        this.setState({
            grupo: e ? e.label : false
        });
    };
    onChangeItem = itemId => {
        let item = this.props.items.filter(item => item.id === itemId)[0];
        item = item ? item : {};

        this.setState({
            id: item.id ? item.id : itemId,
            nombre: item.nombre ? item.nombre : itemId,
            grupo: item.grupo ? item.grupo.nombre : false
        });
    };

    calcularSubtotal = (costo, itbis) => {
        const { useItbis } = this.props;

        if (useItbis === 'aplicado') {
            return costo - itbis;
        }

        return costo;
    };

    calcularDescuento = (costo, descuento) => {
        return costo * (descuento / 100);
    };

    calcularItbis = (costo) => {
        const { itbis, useItbis } = this.props;

        if (useItbis === 'aplicado') {
            return (costo - (costo / itbis));
        }
        if (useItbis === 'no-aplicado') {
            return costo * itbis;
        }
        return 0;
    };

    calcularTotal = (costo, descuento, cantidad, unidad = false) => {
        if (unidad) {
            return (costo - descuento);
        }

        return (costo - descuento) * cantidad;
    };
    render() {
        const { index, item, removeItem, items, grupos, itbis, useItbis } = this.props;
        const { id, nombre, cantidad, descuento, costo, grupo } = this.state;

        const desc       = this.calcularDescuento(costo, descuento);
        const costoTotal = this.calcularTotal(costo, desc, cantidad);
        const totalItbis = this.calcularItbis(costoTotal);
        const subtotal   = this.calcularSubtotal(costoTotal, totalItbis);
        const total = useItbis === 'no-aplicado' ? subtotal + totalItbis : subtotal;

        const precioUnidad = this.calcularTotal(costo, desc, true);
        const totalUnidad = useItbis === 'aplicado' ? precioUnidad : precioUnidad + this.calcularItbis(precioUnidad);

        return (
            <tr>
                <td>{index + 1}</td>
                <td>
                    <Select
                        isClearable={true}
                        type='text'
                        name={`items[${index}][item_id]`}
                        placeholder={"Buscar Item..."}
                        isLoading={items.length === 0}
                        loadingMessage={() => "Cargando items..."}
                        value={
                            id && {
                                value: id,
                                label: nombre
                            }
                        }
                        onChange={e => {
                            if (!e) e = {};
                            this.onChangeItem(e.value);
                        }}
                        maxMenuHeight={200}
                        options={items.map(item => ({
                            label: item.referencia + " - " + item.nombre,
                            value: item.id
                        }))}
                    />
                </td>
                <td>
                    <input
                        type='number'
                        name={`items[${index}][cantidad]`}
                        placeholder='Cantidad'
                        value={cantidad}
                        step='0.01'
                        onChange={e =>
                            this.onChangeInput("cantidad", e.target.value)
                        }
                        className='form-control'
                    />
                </td>
                <td>
                    <input type="hidden" name={`items[${index}][costo]`} value={totalUnidad} />
                    <input
                        type='number'
                        name={`items[${index}][costo_neto]`}
                        placeholder='Costo UND.'
                        value={costo}
                        step='0.01'
                        onChange={e =>
                            this.onChangeInput("costo", e.target.value)
                        }
                        className='form-control'
                    />
                </td>
                <td>
                    <input
                        type='number'
                        name={`items[${index}][descuento]`}
                        placeholder='Descuento'
                        value={descuento}
                        step='0.01'
                        onChange={e =>
                            this.onChangeInput("descuento", e.target.value)
                        }
                        className='form-control'
                    />
                </td>
                <td>
                    <Select
                        isClearable={true}
                        type='text'
                        name={`items[${index}][grupo_id]`}
                        placeholder='Grupo'
                        onChange={this.onChangeGrupo}
                        value={
                            grupo && {
                                value: grupo,
                                label: grupo
                            }
                        }
                        maxMenuHeight={200}
                        options={grupos.map(grupo => ({
                            label: grupo.nombre,
                            value: grupo.nombre
                        }))}
                    />
                </td>
                {itbis > 0 && (
                    <td className='text-right'>{formatCurrency(totalItbis)}</td>
                )}
                <td className='text-right'>
                    {formatCurrency(total)}
                </td>
                <td className='text-right'>
                    <button
                        type='button'
                        className='btn btn-danger'
                        onClick={() => removeItem(item.id)}>
                        <i className='fas fa-trash'></i>
                    </button>
                </td>
            </tr>
        );
    }
}
